import React from 'react';
import { useSelector } from 'react-redux';
import StatusTable from './StatusTable';
import { AreaBox, ModuleStatusListContainer } from './ModuleStatusList.css';
import { GiEmptyHourglass } from 'react-icons/gi';

const ModuleStatusList = () => {
  const gasLog = useSelector((store) => store.gasLog).gas;

  if (!gasLog) {
    return <ModuleStatusListContainer></ModuleStatusListContainer>;
  }

  // 'none'(미수신) 상태 필터하여 미표시. - 250418 담당자 수정 요청 사항 적용
  const filteredLog = gasLog.filter((data) => data.status !== 'none');

  if (filteredLog.length === 0) {
  // if (gasLog.length === 0) {
    return (
      <ModuleStatusListContainer>
        <div className="module-empty">
          <GiEmptyHourglass />
          <span>현재 가동 중인 장치가 없습니다</span>
        </div>
      </ModuleStatusListContainer>
    );
  }

  return (
    <ModuleStatusListContainer>
      <div className="criterion-box">
        <table>
          <thead>
            <tr className="criterion-name-tr">
              <td className="area-status-td">장치상태</td>
              <td className="area-name-td location-td">위치</td>
              <td className="area-name-td">장치명</td>
              <td>O<sub>2</sub></td>
              <td>CO<sub>2</sub></td>
              <td>H<sub>2</sub>S</td>
              <td>CO</td>
              <td>CH4</td>
              <td>CH<sub>3</sub>OH</td>
              <td>NH<sub>3</sub></td>
              <td>rssi</td>
            </tr>
          </thead>
          {/* 미수신 상태 필터링된 데이터만 표시 */}
          {filteredLog.map((data) => {
          // {gasLog.map((data) => {
            console.log('a\n', data);
            return (
              <StatusTable key={`${data.areaNo}-${data.areaNm}`} data={data} />
            );
          })}
        </table>
      </div>
    </ModuleStatusListContainer>
  );
};

export default ModuleStatusList;
